<div class="card step-card flex flex-column">
  <div class="grid">
    <div class="flex flex-column sm:flex-row">
      <div class="col-12 md:col-12 lg:col-3 xl:col-3">
        <p-table
          [value]="measurements"
          [responsive]="true"
          [autoLayout]="true"
          breakpoint="1800px"
          styleClass="p-datatable-sm"
          [scrollable]="true"
          scrollHeight="250px"
          class="w-full"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{'model.sensors' | transloco}} (*)</th>
              <th class="w-4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-measurement>
            <tr >
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}} (*)</span>
                <p class="text-right md:text-left">{{measurement.name}}</p>
              </td>
              <td class="flex-row-reverse">
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <button
                  (click)="addSensor(measurement.name)"
                  pButton
                  pRipple
                  class="p-button-rounded p-button-text mr-2"
                  icon="pi pi-plus"
                  [disabled]="!('ROLE_ADMIN' | userHasRole)"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col">
        <form *ngIf="measurementExpressionForm" [formGroup]="measurementExpressionForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}} (*)</label>
              </div>
              <div class="col-12">
                <input pInputText id="name" type="text" class="w-full" formControlName="name">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}} </label>
              </div>
              <div class="col-12">
                <input pInputText id="description" type="text" class="w-full" formControlName="description">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="alias">{{'attribute.alias' | transloco}} </label>
              </div>
              <div class="col-12">
                <input pInputText id="alias" type="text" class="w-full" formControlName="alias">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label >{{'model.sensorType' | transloco}} (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown
                  [placeholder]="'select.type' | transloco"
                  [options]="measurementTypes"
                  [disabled]="measurementTypesDisabled || !('ROLE_ADMIN' | userHasRole)"
                  styleClass="dropdown-width-md"
                  formControlName="measurementType"
                  optionLabel="sensor"
                ></p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-8">
              <div class="form-field col-12">
                <label for="expression">{{'attribute.expression' | transloco}} (*)</label>
              </div>
              <div class="col-12">
                <textarea pInputTextarea [rows]="3" [cols]="50" id="expression" autoResize="autoResize" class="w-full" formControlName="expression"></textarea>
              </div>
            </div>
          </div>
          <div class="mb-3 flex justify-content-end">
            <div class="mt-auto">
              <button
                *ngIf="!rowEdit"
                [label]="'new.expression' | transloco"
                (click)="checkExpression()"
                [disabled]="!measurementExpressionForm?.valid || !('ROLE_ADMIN' | userHasRole)"
                pButton
                pRipple
                icon="pi pi-plus"
                iconPos="left"
              ></button>
              <button
                *ngIf="rowEdit"
                [label]="'edit.expression' | transloco"
                (click)="checkExpression(true)"
                [disabled]="!measurementExpressionForm?.valid || !('ROLE_ADMIN' | userHasRole)"
                pButton
                pRipple
                icon="pi pi-pencil"
                iconPos="left"
              ></button>

            </div>
          </div>
        </form>
      </div>
    </div>
    <div  class="my-5 col-12 lg:col-12 p-datatable p-component">
      <p-table
        *ngIf="deviceExpressions.length > 0"
        [value]="deviceExpressions"
        editMode="row"
        responsiveLayout="scroll"
        scrollHeight="250px"
        [responsive]="true"
        breakpoint="1800px"
        styleClass="p-datatable-striped"
        [tableStyle]="{ width: 'max-content'}"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{'attribute.name' | transloco}} (*)</th>
            <th>{{'attribute.description' | transloco}}</th>
            <th>{{'attribute.alias' | transloco}}</th>
            <th>{{'model.sensorType' | transloco}} (*)</th>
            <th>{{'attribute.expression' | transloco}} (*)</th>
            <th class="w-10rem">
              {{'common.actions' | transloco}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-expression let-rowIndex="rowIndex" >
          <tr >
            <td>
              <span class="p-column-title">{{'attribute.name' | transloco}} (*)</span>
              {{expression.name}}
            </td>
            <td>
              <span class="p-column-title">{{'attribute.description' | transloco}} (*)</span>
              {{expression.description}}
            </td>
            <td>
              <span class="p-column-title">{{'attribute.alias' | transloco}} (*)</span>
              {{expression.alias}}
            </td>
            <td>
              <span class="p-column-title">{{'model.sensorType' | transloco}} (*)</span>
              {{expression.measurementType.sensor}}
            </td>
            <td>
              <span class="p-column-title">{{'attribute.expression' | transloco}} (*)</span>
              {{expression.expression}}
            </td>
            <td class="text-center">
              <span class="p-column-title">{{'common.delete' | transloco}}</span>
              <button
                (click)="onRowEdit(rowIndex)"
                pButton
                pRipple
                class="p-button-rounded p-button-text"
                type="button"
                icon="pi pi-pencil"
                *ngIf="'ROLE_ADMIN' | userHasRole"
              ></button>
              <button
                (click)="onRowDelete(rowIndex)"
                pButton
                pRipple
                class="p-button-rounded p-button-text p-button-danger"
                type="button"
                icon="pi pi-trash"
                *ngIf="'ROLE_ADMIN' | userHasRole"
              ></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">
              <p class="w-full text-xl text-center p-6 font-italic">{{ 'empty.expressions' | transloco }}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>


  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="onPreviousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          (click)="onNextStep()"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
